import React, { useEffect, useState } from 'react';
import { Mic } from 'lucide-react';
import CallRecordingPlayer from './CallRecordingPlayer';
import { VoiceAiService } from '../services/voiceAiService';

export default function VoiceAiCallRecording({ requestId, callId, compact = false }) {
  const [state, setState] = useState({
    loading: true,
    src: '',
    error: '',
    pending: false,
    missing: false,
    callId: callId || '',
  });

  useEffect(() => {
    let cancelled = false;
    let objectUrl = '';
    setState({ loading: true, src: '', error: '', pending: false, missing: false, callId: callId || '' });

    (async () => {
      if (!requestId && !callId) {
        if (!cancelled) setState((prev) => ({ ...prev, loading: false, missing: true }));
        return;
      }
      const result = await VoiceAiService.fetchRecording({ requestId, callId });
      if (cancelled) return;
      if (result.ok && result.blob) {
        objectUrl = URL.createObjectURL(result.blob);
        if (cancelled) {
          URL.revokeObjectURL(objectUrl);
          return;
        }
        setState({
          loading: false,
          src: objectUrl,
          error: '',
          pending: false,
          missing: false,
          callId: result.callId || callId || '',
        });
        return;
      }
      setState({
        loading: false,
        src: '',
        error: result.status === 401
          ? 'Login again to play this recording.'
          : (result.status === 404 ? '' : (result.error || '')),
        pending: !!result.pending,
        missing: result.status === 404,
        callId: result.callId || callId || '',
      });
    })();

    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [requestId, callId]);

  if ((!requestId && !callId) || state.loading || state.missing) return null;
  if (!state.src && !state.pending && !state.error) return null;

  return (
    <div className={compact ? 'mb-3 rounded-lg border border-violet-200 bg-violet-50 p-3' : 'bg-white rounded-xl shadow-sm border border-violet-200 p-6 mb-4'}>
      <div className="flex items-center gap-2 mb-2">
        <Mic size={compact ? 16 : 18} className="text-violet-600" />
        <h2 className={compact ? 'text-sm font-bold text-gray-900' : 'text-lg font-bold text-gray-900'}>
          Voice AI recording
        </h2>
        {state.callId ? <span className="text-xs text-gray-500">#{state.callId}</span> : null}
      </div>
      {state.src ? (
        <CallRecordingPlayer src={state.src} className="w-full" showDownload compact={compact} />
      ) : state.pending ? (
        <p className="text-sm text-gray-600">Recording process ho rahi hai. Thodi der baad refresh kijiye.</p>
      ) : (
        <p className="text-sm text-gray-600">{state.error || 'Recording available nahi hai.'}</p>
      )}
    </div>
  );
}
